
    <!--
 * 竖版-抽奖
 * @LastEditTime: Tue Dec 17 2024 15:43:03 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_6FRM32"  :class="[`normal main-color`,`u_c_6FRM32`]" ><div id="u_c_6B6A33"  :class="[`${ compData.title ? 'text' : '' }`,`normal `,`u_c_6B6A33`]" ><div id="u_c_07IV34"  v-html="compData.title || langData.lotteryTitle" :class="[`normal`,`u_c_07IV34`]" ></div></div><div id="u_c_2V2935"  :class="[`${ compData.title ? 'text' : '' }`,`normal `,`u_c_2V2935`]" ><div id="u_c_ORRX36"  v-html="compData.subTitle || langData.lotterySubTitle" :class="[`normal`,`u_c_ORRX36`]" ></div></div><div id="u_c_603N43"  :class="[`normal txt`,`u_c_603N43`]" ><span id="u_c_5SDU44"  :class="[`normal txt`,`u_c_5SDU44`]" >{{langData.lotteryCost}}<span id="u_c_17O664"  :class="[`normal highlight`,`u_c_17O664`]" >{{pageData.lotteryCost}}</span>{{`${ langData.lotteryCoupon }`}}</span><span id="u_c_NV8K46"  :class="[`normal txt`,`u_c_NV8K46`]" >{{`${ langData.lotteryTimes }`}}</span><span id="u_c_ZW3O66"  :class="[`normal highlight`,`u_c_ZW3O66`]" >{{pageData.lotteryTimes}}</span></div><div id="u_c_GUYI137"  :class="[`normal`,`u_c_GUYI137`]" ><div id="u_c_SPID29"  :class="[`normal`,`u_c_SPID29`]" >{{langData.curLotteryCoupon}}<span id="u_c_609N139"  :class="[`normal highlight`,`u_c_609N139`]" >{{pageData.curLotteryCoupon}}</span></div><div id="u_c_YBQY24"  :class="[`normal`,`u_c_YBQY24`]" ><span id="u_c_GQCU25"  :class="[`normal txt`,`u_c_GQCU25`]" @click="u_c_GQCU25_event_Y90J29($event)">{{`[${ langData.refresh }]`}}</span><span id="u_c_NY9J27"  :class="[`normal txt`,`u_c_NY9J27`]" @click="u_c_NY9J27_event_Y90J29($event)">{{`[${ langData.myPackage }]`}}</span></div></div><div id="u_c_3NV472"  :class="[`normal`,`u_c_3NV472`]" ><div id="u_c_59TC73"  v-for="(giftItem, giftI) in compData.lotteryList" :key="giftI" :data-index="giftItem.id" :class="[`normal btn-light`,`u_c_59TC73`]" @click="u_c_59TC73_event_5MJO60($event,giftI)"><div id="u_c_S4DS74"  v-show="giftItem.state == 2 || giftItem.state == void 0 && giftI == 0" :class="[`normal`,`u_c_S4DS74`]" ></div><div id="u_c_VRIH75"  v-show="giftItem.cur == 1 || giftItem.cur == void 0 && giftI == 1" :class="[`normal`,`u_c_VRIH75`]" ></div><div id="u_c_PC0C76"  v-show="giftItem.state == 2 || giftItem.state == void 0 && giftI == 0" :class="[`normal`,`u_c_PC0C76`]" ></div><div id="u_c_XUTD77"  :style="`background-image:url(${ giftItem.pic })`" :class="[({ has:     giftItem.state == 2 }),`normal`,`u_c_XUTD77`]" ></div></div></div><div id="u_c_05SV78"  :class="[`normal`,`u_c_05SV78`]" ><a id="u_c_X39D79" href="javascript:;" :class="[pageData.curLotteryCoupon < pageData.lotteryCost ? 'has' : '',`normal page-common-btn `,`u_c_X39D79`]" @click="u_c_X39D79_event_334420($event)"><div id="u_c_ZBZS80"  :class="[`normal page-common-btn lottery-btn-text`,`u_c_ZBZS80`]" >{{langData.startLottery}}</div></a><a id="u_c_1OP482" href="javascript:;" v-if="pageData.isEdit ? compData.is10 : compData.is10 && pageData.curLotteryCoupon >= pageData.lotteryCost * 10" :class="[`${ compData.canClick ? 'btn-light' : '' }`,`normal page-common-btn lottery-btn`,`u_c_1OP482`]" @click="u_c_1OP482_event_334420($event)"><div id="u_c_56AF83"  :class="[`normal page-common-btn lottery-btn-text`,`u_c_56AF83`]" >{{langData.lottery10}}</div></a></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"subTitle":`活动期间，消耗在活动中获得的抽奖券可进行抽奖，中奖率100%`,"lotteryList":[{"name":"九宫格抽奖第1个奖励","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png"},{"name":"九宫格抽奖第2个奖励","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1715240279211-93.png"},{"name":"九宫格抽奖第3个奖励","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1715240279211-93.png"},{"name":"九宫格抽奖第4个奖励","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1715240279211-93.png"},{"name":"九宫格抽奖第5个奖励","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1715240279211-93.png"},{"name":"九宫格抽奖第6个奖励","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1715240279211-93.png"},{"name":"九宫格抽奖第7个奖励","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1715240279211-93.png"},{"name":"九宫格抽奖第8个奖励","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1715240279211-93.png"},{"name":"九宫格抽奖第9个奖励","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1715240279211-93.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true},"zh-CN":{"subTitle":`活动期间，消耗在活动中获得的抽奖券可进行抽奖，中奖率100%`,"lotteryList":[{"name":"加速60分钟 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330345803062.png"},{"name":"普通招募硬币 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626493427996.png"},{"name":"荣耀印记 *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626471408387.png"},{"name":"精造装置 *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626461087590.png"},{"name":"中级招募硬币 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626443392753.png"},{"name":"5%OFF优惠券 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"升星选择补给箱 *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"},{"name":"强化选择补给箱 *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"},{"name":"7%OFF优惠券 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"高级招募硬币 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626435472507.png"},{"name":"VIP点数100点 *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626441825441.png"},{"name":"9%OFF优惠券 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"器官强化方案 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626460601461.png"},{"name":"精密升星选择补给箱 *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"},{"name":"5星英雄万能碎片*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true},"zh-TW":{"subTitle":`活动期间，消耗在活动中获得的抽奖券可进行抽奖，中奖率100%`,"lotteryList":[{"name":"加速60分鐘 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330345803062.png"},{"name":"普通招募硬幣 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626493427996.png"},{"name":"榮耀印記 *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626471408387.png"},{"name":"精造裝置 *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626461087590.png"},{"name":"中級招募硬幣 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626443392753.png"},{"name":"5%off 優惠劵 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"升星選擇補給箱 *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"},{"name":"強化選擇補給箱 *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"},{"name":"7%off 優惠劵 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"高級招募硬幣 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626435472507.png"},{"name":"VIP點數100點 *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626441825441.png"},{"name":"9%off 優惠劵 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"器官強化方案 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626460601461.png"},{"name":"精密升星選擇補給箱 *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"},{"name":" 5星英雄萬能碎片*10 ","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true},"en-US":{"subTitle":``,"lotteryList":[{"name":"60-min Speedup *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330345803062.png"},{"name":"Basic Recruit Coin *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626493427996.png"},{"name":"Mark of Glory *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626471408387.png"},{"name":"Gear Refiner *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626461087590.png"},{"name":"Int. Recruit Coin *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626443392753.png"},{"name":"5% OFF Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Promote Choice Box *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"},{"name":"Enhance Choice Box *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"},{"name":"7% OFF Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Adv. Recruit Coin *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626435472507.png"},{"name":"100 VIP Pts *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626441825441.png"},{"name":"9% OFF Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Bioenhance Scheme *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626460601461.png"},{"name":"Promote Choice Box II *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"},{"name":" 5★ Hero Perfect Frag*10 ","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true},"ja-JP":{"subTitle":``,"lotteryList":[{"name":"ブースト（60分間） *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330345803062.png"},{"name":"リクルートコイン *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626493427996.png"},{"name":"グローリー *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626471408387.png"},{"name":"ギア装置 *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626461087590.png"},{"name":"ⓡ（リクルートコインミニ） *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626443392753.png"},{"name":"5%OFF\nクーポン *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"選択型プロモート補給 *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"},{"name":"選択型強化補給 *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"},{"name":"7%OFF\nクーポン *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Ⓡ（リクルートコイン） *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626435472507.png"},{"name":"VIPPt×100 *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626441825441.png"},{"name":"9%OFF\nクーポン *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"器官強化プラン *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626460601461.png"},{"name":"選択型プロモート補給（エリート） *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"},{"name":" ★5英雄の万能欠片*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true},"ko-KR":{"subTitle":``,"lotteryList":[{"name":"60분 가속 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330345803062.png"},{"name":"일반 모집 코인 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626493427996.png"},{"name":"영광 인장 *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626471408387.png"},{"name":"정제 장치 *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626461087590.png"},{"name":"중급 모집 코인 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626443392753.png"},{"name":"5% 할인쿠폰 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"승성 선택 보급 상자 *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"},{"name":"강화 선택 보급상자 *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"},{"name":"7% 할인쿠폰 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"고급 모집 코인 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626435472507.png"},{"name":"VIP 100포인트 *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626441825441.png"},{"name":"9% 할인쿠폰 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"신체 기관 강화 플랜 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626460601461.png"},{"name":"정밀 승성 선택 보급 상자 *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"},{"name":" 5성 영웅 만능 조각*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true},"th-TH":{"subTitle":``,"lotteryList":[{"name":"เร่งสปีด60นาที *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330345803062.png"},{"name":"เหรียญเกณฑ์ I *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626493427996.png"},{"name":"ตรากลอรี่ *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626471408387.png"},{"name":"เครื่องกลั่น *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626461087590.png"},{"name":"เหรียญเกณฑ์ II *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626443392753.png"},{"name":"คูปองลด 5% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"หีบเลือกอัปดาว *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"},{"name":"หีบเลือกตีบวก *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"},{"name":"คูปองลด 7% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"เหรียญเกณฑ์ III *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626435472507.png"},{"name":"แต้มVIPx100 *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626441825441.png"},{"name":"คูปองลด 9% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"แผนตีบวกอวัยวะ *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626460601461.png"},{"name":"หีบเลือกอัปดาวก่อสร้าง *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"},{"name":" Mảnh Anh hùng 5 Sao Vạn Năng*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true},"vi-VN":{"subTitle":`活动期间，消耗在活动中获得的抽奖券可进行抽奖，中奖率100%`,"lotteryList":[{"name":"Tăng tốc 60 phút *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330345803062.png"},{"name":"Xu Chiêu Mộ-Thường *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626493427996.png"},{"name":"Ấn Ký Vinh Dự *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626471408387.png"},{"name":"Tinh Luyện Trang Bị *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626461087590.png"},{"name":"Xu Chiêu Mộ-Trung *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626443392753.png"},{"name":"Phiếu Ưu Đãi 5% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Rương Lựa Chọn Tăng Sao *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"},{"name":"Rương Chọn Cường Hoá *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"},{"name":"Phiếu Ưu Đãi 7% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Xu Chiêu Mộ-Cao *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626435472507.png"},{"name":"100 điểm VIP *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626441825441.png"},{"name":"Phiếu Ưu Đãi 9% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"P.Án C.Hóa Nội Tạng *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626460601461.png"},{"name":"Rương Chọn Tăng Sao Tuyệt Mật *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"},{"name":" 5★ Held-Perfektes Fragment*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true},"de-DE":{"subTitle":``,"lotteryList":[{"name":"60 Min Beschleunigen *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330345803062.png"},{"name":"Grund Rekrutmünze *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626493427996.png"},{"name":"Zeichen des Ruhms *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626471408387.png"},{"name":"Ausrüstung Verfeiner *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626461087590.png"},{"name":"Mittl. Rekrutmünze *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626443392753.png"},{"name":"5% RABATT-Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Befördern Auswahlkiste *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"},{"name":"Verbessern Auswahlkiste *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"},{"name":"7% RABATT-Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Fortg. Rekrutmünze *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626435472507.png"},{"name":"100 VIP Pkte *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626441825441.png"},{"name":"9% RABATT-Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Bioverstärkung Plan *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626460601461.png"},{"name":"Befördern Auswahlkiste II *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"},{"name":" Fragment parfait de héros 5★*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true},"fr-FR":{"subTitle":``,"lotteryList":[{"name":"Accélération 60-min *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330345803062.png"},{"name":"Pièce recrutement de base *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626493427996.png"},{"name":"Marque de gloire *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626471408387.png"},{"name":"Raffineur d'équipement *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626461087590.png"},{"name":"Pièce recrutement intermédiaire *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626443392753.png"},{"name":"Coupon 5% de Réduction *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Boîte choix promotion *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"},{"name":"Boîte de renforcement au choix *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"},{"name":"Coupon 7% de Réduction *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Pièce recrutement av. *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626435472507.png"},{"name":"100 Pt. VIP *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626441825441.png"},{"name":"Coupon 9% de Réduction *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Schéma Biorenforceur *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626460601461.png"},{"name":"Boîte choix promotion II *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"},{"name":" Идеальный Фрагмент 5★ Героя*2 ","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true},"ru-RU":{"subTitle":``,"lotteryList":[{"name":"Ускорение (60 мин.) *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330345803062.png"},{"name":"Монета Базового Найма *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626493427996.png"},{"name":"Знак Славы *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626471408387.png"},{"name":"Модернизатор Снаряжения *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626461087590.png"},{"name":"Монета Хорошего Найма *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626443392753.png"},{"name":"Купон на 5% скидку *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Ящик с Промоутерами на Выбор *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"},{"name":"Ящик с Улучшениями на Выбор *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"},{"name":"Купон на 7% скидку *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Монета Крутого Найма *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626435472507.png"},{"name":"100 Пунктов VIP *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626441825441.png"},{"name":"Купон на 9% скидку *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"План Биомодификации *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626460601461.png"},{"name":"Ящик с Промоутерами на Выбор II *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"},{"name":" Frag. Perfecto de Héroe 5★*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true},"es-ES":{"subTitle":``,"lotteryList":[{"name":"Aceleración de 60 min *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330345803062.png"},{"name":"Moneda de Reclutamiento Básica *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626493427996.png"},{"name":"Marca de Gloria *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626471408387.png"},{"name":"Refinador de Equipos *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626461087590.png"},{"name":"Moneda de Reclutamiento Intermedia *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626443392753.png"},{"name":"Cupón de descuento del 5% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Caja de Selección de Promoción *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"},{"name":"Mejora la Caja de Elección *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"},{"name":"Cupón de descuento del 7% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Moneda de Reclutamiento Avanzada *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626435472507.png"},{"name":"100 Puntos VIP *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626441825441.png"},{"name":"Cupón de descuento del 9% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Plan de las Biomejoras *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626460601461.png"},{"name":"Caja de Selección de Promoción II *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"},{"name":" Fragmento de Herói Perfeito 5★*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true},"pt-PT":{"subTitle":``,"lotteryList":[{"name":"Aceleração de 60 minutos *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330345803062.png"},{"name":"Moeda Básica de Recrutamento *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626493427996.png"},{"name":"Marca da Glória *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626471408387.png"},{"name":"Refinador de Equipamentos *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626461087590.png"},{"name":"Int. Moeda de Recrutar *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626443392753.png"},{"name":"Cupom de 5% de desconto *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Caixa de Escolha de Promoção *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"},{"name":"Caixa da Escolha de Melhorias *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"},{"name":"Cupom de 7% de desconto *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Adv. Moeda de Recrutar *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626435472507.png"},{"name":"100 Pontos VIP *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626441825441.png"},{"name":"Cupom de 9% de desconto *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Esquema de Melhoria de Órgãos *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626460601461.png"},{"name":"Caixa de Escolha de Promoção II *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"},{"name":" Framm. Eroe Perfetto 5★*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true},"it-IT":{"subTitle":``,"lotteryList":[{"name":"Velocizz. 60-min *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330345803062.png"},{"name":"Gettone Recluta Basica *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626493427996.png"},{"name":"Marchio di Gloria *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626471408387.png"},{"name":"Raffinatore Equip. *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626461087590.png"},{"name":"Gettone Recluta Intermedia *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626443392753.png"},{"name":"Coupon SCONTO 5% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Scatola Scelta Promozione *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"},{"name":"Scatola Scelta Migliora *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"},{"name":"Coupon SCONTO 7% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Gettone Recluta Avanzata *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626435472507.png"},{"name":"100 Pti VIP *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626441825441.png"},{"name":"Coupon SCONTO 9% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Schema Biopotenziatore *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626460601461.png"},{"name":"Scatola Scelta Promozione II *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"},{"name":" 5★ Kahraman Mükemmel Parça*10 ","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true},"tr-TR":{"subTitle":``,"lotteryList":[{"name":"60-dk Hızlandırma *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330345803062.png"},{"name":"Temel İşe Alım Parası *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626493427996.png"},{"name":"Şan Mührü *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626471408387.png"},{"name":"Teçhizat Arıtıcı *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626461087590.png"},{"name":"Ara İşe Alım Parası *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626443392753.png"},{"name":"%5 İndirim Kuponu *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"İlerletme Seçim Kutusu *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"},{"name":"Büyütme Seçimi Kutusu *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"},{"name":"%7 İndirim Kuponu *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Gel. İşe Alım Parası *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626435472507.png"},{"name":"100 VIP Puanı *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626441825441.png"},{"name":"%9 İndirim Kuponu *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Bio-Geliştirme Şeması *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626460601461.png"},{"name":"İlerletme Seçim Kutusu II *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"},{"name":" Idealny Frag. 5★ Herosa*10 ","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true},"pl-PL":{"subTitle":``,"lotteryList":[{"name":"60-min. Przyśpieszenie *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330345803062.png"},{"name":"Moneta Rekruta Podstawowego *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626493427996.png"},{"name":"Odznaka Chwały *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626471408387.png"},{"name":"Rafiner Sprzętu *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626461087590.png"},{"name":"Moneta Średniozaawansowanego Rekruta *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626443392753.png"},{"name":"Kupon 5% ZNIŻKI *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Pudełko z Wyborem Promocji *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"},{"name":"Pudło Wyboru Wzmocnienia *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"},{"name":"Kupon 7% ZNIŻKI *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Moneta Rekruta Zaawansowanego *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626435472507.png"},{"name":"100 Pkt VIP *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626441825441.png"},{"name":"Kupon 9% ZNIŻKI *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Biowzmacniacz Schemat *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626460601461.png"},{"name":"Pudełko z Wyborem Promocji II *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"},{"name":" Fragmen Hero Universal 5★*10 ","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true},"id-ID":{"subTitle":``,"lotteryList":[{"name":"Speed up 60 menit *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330345803062.png"},{"name":"Normal Rekrut Coin *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626493427996.png"},{"name":"Mark of Glory *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626471408387.png"},{"name":"Gear Refiner *10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626461087590.png"},{"name":"Medium Rekrut Coin *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626443392753.png"},{"name":"Kupon 5%off *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Star up Choice Supply Box *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"},{"name":"Enhance Choice Supply Box *2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"},{"name":"Kupon 7%off *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Adv. Rekrut Coin *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626435472507.png"},{"name":"100 poin VIP *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626441825441.png"},{"name":"Kupon 9%off *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"Solusi Enhance Organ *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626460601461.png"},{"name":"Star up Choice Supply Box II *4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"},{"name":"قطعة بطل متعددة 5★*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true},"ar-SA":{"subTitle":``,"lotteryList":[{"name":"1* تسريع 60 دقيقة","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330345803062.png"},{"name":"1* عملات التجنيد العادي","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626493427996.png"},{"name":"10* وسام المجد","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626471408387.png"},{"name":"10* مطور المعدات","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626461087590.png"},{"name":"1* عملات التجنيد المتوسط","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626443392753.png"},{"name":"1* قسيمة تخفيض 5%","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"2* صندوق ترقية النجوم","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"},{"name":"2* اختيار صندوق الإمدادات","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png"},{"name":"1* قسيمة تخفيض 7%","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"1* عملات التجنيد المتقدم","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626435472507.png"},{"name":"4* 100 نقطة VIP","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626441825441.png"},{"name":"1* قسيمة تخفيض 9%","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636640843714131.png"},{"name":"1* طريقة تقوية الأعضاء","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626460601461.png"},{"name":"4* صندوق ترقية النجوم II","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"},{"name":"1* تسريع 60 دقيقة","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png"}],"canClick":true,"title":``,"luckyGift":[{giftIcon: '', giftName: ''}],"showLucky":true,"luckyGiftMini":[{giftIcon: '', giftName: ''}],"showLuckyGiftMini":false,"is10":true}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '抽奖';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {});
const checkIsLogin = inject("checkIsLogin", () => {});
const initActivity = inject("initActivity", () => {});
const showTips = inject("showTips", (txt, code) => {});
const showGetSucc = inject("showGetSucc", (type, pic, name) => {});
const listData = inject("listData", {});
const canClickRefresh = inject("canClickRefresh", true);
const giftInfo = inject("giftInfo", {});
const getCurLink = inject("getCurLink", (link) => {});

const curPlatform = utils.getMainHost() == "gm99.com" ? "gm99" : "global";

const init = () => {
  compData.canClick = true;
  compData.showLuckyGiftMini = false
  compData.lotteryList.forEach((item) => {
    item.state = 0;
  });
  pageData.bigAwardName = compData.luckyGift[0].giftName
  pageData.smallAwardName = compData.luckyGiftMini[0].giftName
  compData.storeLink = getCurLink(compData.storeLink);
};

watch(
  () => listData,
  (value) => {
    if (value && value.lotteryList) {
      let confList = _.cloneDeep(compData.lotteryList);
      compData.lotteryList = [];
      value.lotteryList.forEach((item, index) => {
        if (confList[index]) {
          compData.lotteryList.push({
            pic: confList[index].pic,
            state: 0,
            id: item.id,
            awardWeight: item.award_weight,
            awardStock: item.award_stock,
            cur: 0,
            name: confList[index].name,
            awardDetail: confList[index].name,
          });
        }
      });
      giftInfo.lotteryList = compData.lotteryList;
    }
  }, {
    deep: true
  }
);
init();

const lotteryTime = 10;
const lotteryTimes = ref(lotteryTime);

const resetLottery = () => {
  compData.lotteryList.forEach((item) => {
    item.cur = 0;
  });
};

const getRandomId = (arr, pre) => {
  let i = utils.randomNumber(0, arr.length);
  if (+i == +pre) {
    return getRandomId(arr, pre);
  }
  return i;
};

const renderCur = async (arr, latest, pre) => {
  let i = getRandomId(arr, pre);
  resetLottery();
  let curIndex = lotteryTimes.value == 1 ? latest : arr[i];
  compData.lotteryList[curIndex].cur = 1;
  lotteryTimes.value--;
  await utils.sleep(0.3);
  if (lotteryTimes.value) {
    return renderCur(arr, latest, i);
  }
};
const getGiftInfo = (data) => {
  let info = {
    index: -1,
    isBigAward: false,
  };
  let curId = compData.lotteryList.findIndex(
    (item) => item.id == data.key
  );
  if (~curId) {
    info = compData.lotteryList[curId];
    info["index"] = curId;
    info["name"] = info.awardDetail;
  }
  if (data.awardType == "sendSerial") {
    info.name = `${langData.giftCode}：${data.card}`;
  }
  // if (data.awardId == giftInfo.bigAwardId) {
  //   info.isBigAward = true;
  //   info.name = compData.luckyGift[0].giftName;
  //   info.pic = compData.luckyGift[0].giftIcon;
  // }
  // if (data.awardId == giftInfo.smallAwardId) {
  //   info.name = compData.luckyGiftMini[0].giftName;
  //   info.pic = compData.luckyGiftMini[0].giftIcon;
  // }
  return info;
};

const excLottery = async () => {
  resetLottery();
  let animList = [];
  compData.lotteryList.forEach((item, index) => {
    if (item.state < 2) {
      animList.push(index);
    }
  });
  let res = await excLotteryAjax();
  if (res.result != 1) {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code);
    return;
  }
  let curItem = getGiftInfo(res.data.lotteryData);
  if (~curItem.index) {
    if (animList.length > 1) {
      lotteryTimes.value = lotteryTime;
      await renderCur(animList, curItem.index);
    }
    // if (pageData.lotteryType == "no_reset") {
    //   compData.lotteryList[curItem.index].state = 2;
    // }
    let awardName = curItem.name;
    if (res.data.lotteryData.awardType == "sendSerial") {
      awardName = res.data.lotteryData.card;
    }
    showGetSucc(res.data.lotteryData.awardType, curItem.pic, awardName);
    resetLottery();
  }
  pageData.curLotteryCoupon = res.data.ticket;
  pageData.lotteryTimes = res.data.lotteryTimes;
};

const excLotteryAjax = async () => {
  const link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=lottery`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=lottery`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=lottery`,
  };
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      language: curLang,
    }),
  });
  return res;
};

// 十连抽
const exec10Lottery = async () => {
  let link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=lotteryMany`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
          pageData.pageId
        }&action=lotteryMany`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
          pageData.pageId
        }&action=lotteryMany`,
  };
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      language: curLang,
    }),
  });
  if (res.result != 1) {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code);
    return;
  }
  let curGiftName = "";
  for (let i in res.data.lotteryData) {
    let curItem = getGiftInfo(res.data.lotteryData[i]);
    console.log(curItem);
    if (~curItem.index) {
      curGiftName += `${curItem.name}<br/><br/>`;
    }
  }
  pageData.curLotteryCoupon = res.data.ticket;
  pageData.lotteryTimes = res.data.lotteryTimes;
  showGetSucc("sendVt", "", curGiftName);
};

// 领取幸运奖励
const getLuckyAward = async (isBigAward) => {
  const bigAwardLink = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=bigLuckyAward`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
          pageData.pageId
        }&action=bigLuckyAward`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
          pageData.pageId
        }&action=bigLuckyAward`,
  };
  const smallAwardLink = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=littleLuckyAward`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
          pageData.pageId
        }&action=littleLuckyAward`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
          pageData.pageId
        }&action=littleLuckyAward`,
  };
  let res = await request.getJSON(
    isBigAward ? bigAwardLink[curPlatform] : smallAwardLink[curPlatform], {
      params: JSON.stringify({
        language: curLang,
      }),
    }
  );
  if (res.result != 1) {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code);
    return;
  }
  let curItem = getGiftInfo(res.data);
  let awardName = curItem.name;
  if (res.data.awardType == "sendSerial") {
    awardName = res.data.card;
  }
  isBigAward
    ?
    (pageData.isBigAwardGot = true) :
    (pageData.isLittleLuckyAwardGot = true);
  showGetSucc(res.data.awardType, curItem.pic, awardName);
};;
      // 刷新的click事件
      const u_c_GQCU25_event_Y90J29= async (e)=>{
        try {if (!checkIsLogin()) return
if (!checkIsBind()) return
if(!canClickRefresh.value)return;
canClickRefresh.value = false;
initActivity();
await utils.sleep(5);
canClickRefresh.value = true;} catch (error) {console.log(error)}
      };
      // 我的背包的click事件
      const u_c_NY9J27_event_Y90J29= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "抽奖-背包",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
pageData.curBagType = 'lottery'
pageData.bagPopupState = true} catch (error) {console.log(error)}
      };
      // 自定义元素A59TC73的click事件
      const u_c_59TC73_event_5MJO60= async (e,index)=>{
        try {pageData.seeGift = [{
  ...compData.lotteryList[index],
  name: compData.lotteryList[index].awardDetail,
}]
pageData.seeGiftPopupState = true;} catch (error) {console.log(error)}
      };
      // 抽奖按钮的click事件
      const u_c_X39D79_event_334420= async (e)=>{
        try {if (!checkIsLogin()) return
if (!checkIsBind()) return
if (!compData.canClick) return
compData.canClick = false
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "点击抽奖",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
if (pageData.curLotteryCoupon < pageData.lotteryCost) {
  compData.canClick = true;
  return;
}
await excLottery()
compData.canClick = true} catch (error) {console.log(error)}
      };
      // 十连抽按钮的click事件
      const u_c_1OP482_event_334420= async (e)=>{
        try {if (!checkIsLogin()) return
if (!checkIsBind()) return
if (!compData.canClick) return
compData.canClick = false
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "点击十连抽奖",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
if (pageData.curLotteryCoupon < pageData.lotteryCost * 10) {
  compData.canClick = true;
  return;
}
await exec10Lottery()
compData.canClick = true} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.default{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_07IV34.normal{
position:relative;

}
}.default{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.default{
.u_c_ORRX36.normal{
position:relative;

}
}.default{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.default{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.default{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.default{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.default{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.default{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.default{
.u_c_SPID29.normal{
position:relative;

}
}.default{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.default{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.default{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.default{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.default{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.default{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.default{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.default{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.default{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.default{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.default{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.default{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.default{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.default{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}.zh-CN{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.zh-CN{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.zh-CN{
.u_c_07IV34.normal{
position:relative;

}
}.zh-CN{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.zh-CN{
.u_c_ORRX36.normal{
position:relative;

}
}.zh-CN{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.zh-CN{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.zh-CN{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.zh-CN{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.zh-CN{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.zh-CN{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.zh-CN{
.u_c_SPID29.normal{
position:relative;

}
}.zh-CN{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.zh-CN{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.zh-CN{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.zh-CN{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.zh-CN{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.zh-CN{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.zh-CN{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.zh-CN{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.zh-CN{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.zh-CN{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.zh-CN{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-CN{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.zh-CN{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.zh-CN{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.zh-CN{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}.zh-TW{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.zh-TW{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.zh-TW{
.u_c_07IV34.normal{
position:relative;

}
}.zh-TW{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.zh-TW{
.u_c_ORRX36.normal{
position:relative;

}
}.zh-TW{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.zh-TW{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.zh-TW{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.zh-TW{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.zh-TW{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.zh-TW{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.zh-TW{
.u_c_SPID29.normal{
position:relative;

}
}.zh-TW{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.zh-TW{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.zh-TW{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.zh-TW{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.zh-TW{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.zh-TW{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.zh-TW{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.zh-TW{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.zh-TW{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.zh-TW{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.zh-TW{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-TW{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.zh-TW{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.zh-TW{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.zh-TW{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}.en-US{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.en-US{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.en-US{
.u_c_07IV34.normal{
position:relative;

}
}.en-US{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.en-US{
.u_c_ORRX36.normal{
position:relative;

}
}.en-US{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.en-US{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.en-US{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.en-US{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.en-US{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.en-US{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.en-US{
.u_c_SPID29.normal{
position:relative;

}
}.en-US{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.en-US{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.en-US{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.en-US{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.en-US{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.en-US{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.en-US{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.en-US{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.en-US{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.en-US{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.en-US{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.en-US{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.en-US{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.en-US{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.en-US{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}.ja-JP{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.ja-JP{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.ja-JP{
.u_c_07IV34.normal{
position:relative;

}
}.ja-JP{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.ja-JP{
.u_c_ORRX36.normal{
position:relative;

}
}.ja-JP{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.ja-JP{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.ja-JP{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.ja-JP{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.ja-JP{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.ja-JP{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.ja-JP{
.u_c_SPID29.normal{
position:relative;

}
}.ja-JP{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.ja-JP{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.ja-JP{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.ja-JP{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ja-JP{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.ja-JP{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.ja-JP{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.ja-JP{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.ja-JP{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.ja-JP{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.ja-JP{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ja-JP{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.ja-JP{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.ja-JP{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.ja-JP{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}.ko-KR{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.ko-KR{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.ko-KR{
.u_c_07IV34.normal{
position:relative;

}
}.ko-KR{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.ko-KR{
.u_c_ORRX36.normal{
position:relative;

}
}.ko-KR{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.ko-KR{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.ko-KR{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.ko-KR{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.ko-KR{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.ko-KR{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.ko-KR{
.u_c_SPID29.normal{
position:relative;

}
}.ko-KR{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.ko-KR{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.ko-KR{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.ko-KR{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ko-KR{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.ko-KR{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.ko-KR{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.ko-KR{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.ko-KR{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.ko-KR{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.ko-KR{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ko-KR{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.ko-KR{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.ko-KR{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.ko-KR{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}.th-TH{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.th-TH{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.th-TH{
.u_c_07IV34.normal{
position:relative;

}
}.th-TH{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.th-TH{
.u_c_ORRX36.normal{
position:relative;

}
}.th-TH{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.th-TH{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.th-TH{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.th-TH{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.th-TH{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.th-TH{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.th-TH{
.u_c_SPID29.normal{
position:relative;

}
}.th-TH{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.th-TH{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.th-TH{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.th-TH{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.th-TH{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.th-TH{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.th-TH{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.th-TH{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.th-TH{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.th-TH{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.th-TH{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.th-TH{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.th-TH{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.th-TH{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.th-TH{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}.vi-VN{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.vi-VN{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.vi-VN{
.u_c_07IV34.normal{
position:relative;

}
}.vi-VN{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.vi-VN{
.u_c_ORRX36.normal{
position:relative;

}
}.vi-VN{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.vi-VN{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.vi-VN{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.vi-VN{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.vi-VN{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.vi-VN{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.vi-VN{
.u_c_SPID29.normal{
position:relative;

}
}.vi-VN{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.vi-VN{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.vi-VN{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.vi-VN{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.vi-VN{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.vi-VN{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.vi-VN{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.vi-VN{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.vi-VN{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.vi-VN{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.vi-VN{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.vi-VN{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.vi-VN{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.vi-VN{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.vi-VN{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}.de-DE{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.de-DE{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.de-DE{
.u_c_07IV34.normal{
position:relative;

}
}.de-DE{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.de-DE{
.u_c_ORRX36.normal{
position:relative;

}
}.de-DE{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.de-DE{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.de-DE{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.de-DE{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.de-DE{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.de-DE{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.de-DE{
.u_c_SPID29.normal{
position:relative;

}
}.de-DE{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.de-DE{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.de-DE{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.de-DE{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.de-DE{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.de-DE{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.de-DE{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.de-DE{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.de-DE{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.de-DE{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.de-DE{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.de-DE{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.de-DE{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.de-DE{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.de-DE{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}.fr-FR{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.fr-FR{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.fr-FR{
.u_c_07IV34.normal{
position:relative;

}
}.fr-FR{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.fr-FR{
.u_c_ORRX36.normal{
position:relative;

}
}.fr-FR{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.fr-FR{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.fr-FR{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.fr-FR{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.fr-FR{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.fr-FR{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.fr-FR{
.u_c_SPID29.normal{
position:relative;

}
}.fr-FR{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.fr-FR{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.fr-FR{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.fr-FR{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.fr-FR{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.fr-FR{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.fr-FR{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.fr-FR{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.fr-FR{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.fr-FR{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.fr-FR{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.fr-FR{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.fr-FR{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.fr-FR{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.fr-FR{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}.ru-RU{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.ru-RU{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.ru-RU{
.u_c_07IV34.normal{
position:relative;

}
}.ru-RU{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.ru-RU{
.u_c_ORRX36.normal{
position:relative;

}
}.ru-RU{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.ru-RU{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.ru-RU{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.ru-RU{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.ru-RU{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.ru-RU{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.ru-RU{
.u_c_SPID29.normal{
position:relative;

}
}.ru-RU{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.ru-RU{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.ru-RU{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.ru-RU{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ru-RU{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.ru-RU{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.ru-RU{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.ru-RU{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.ru-RU{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.ru-RU{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.ru-RU{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ru-RU{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.ru-RU{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.ru-RU{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.ru-RU{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}.es-ES{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.es-ES{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.es-ES{
.u_c_07IV34.normal{
position:relative;

}
}.es-ES{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.es-ES{
.u_c_ORRX36.normal{
position:relative;

}
}.es-ES{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.es-ES{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.es-ES{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.es-ES{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.es-ES{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.es-ES{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.es-ES{
.u_c_SPID29.normal{
position:relative;

}
}.es-ES{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.es-ES{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.es-ES{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.es-ES{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.es-ES{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.es-ES{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.es-ES{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.es-ES{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.es-ES{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.es-ES{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.es-ES{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.es-ES{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.es-ES{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.es-ES{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.es-ES{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}.pt-PT{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.pt-PT{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.pt-PT{
.u_c_07IV34.normal{
position:relative;

}
}.pt-PT{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.pt-PT{
.u_c_ORRX36.normal{
position:relative;

}
}.pt-PT{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.pt-PT{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.pt-PT{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.pt-PT{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.pt-PT{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.pt-PT{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.pt-PT{
.u_c_SPID29.normal{
position:relative;

}
}.pt-PT{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.pt-PT{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.pt-PT{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.pt-PT{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.pt-PT{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.pt-PT{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.pt-PT{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.pt-PT{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.pt-PT{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.pt-PT{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.pt-PT{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.pt-PT{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.pt-PT{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.pt-PT{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.pt-PT{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}.it-IT{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.it-IT{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.it-IT{
.u_c_07IV34.normal{
position:relative;

}
}.it-IT{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.it-IT{
.u_c_ORRX36.normal{
position:relative;

}
}.it-IT{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.it-IT{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.it-IT{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.it-IT{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.it-IT{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.it-IT{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.it-IT{
.u_c_SPID29.normal{
position:relative;

}
}.it-IT{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.it-IT{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.it-IT{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.it-IT{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.it-IT{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.it-IT{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.it-IT{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.it-IT{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.it-IT{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.it-IT{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.it-IT{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.it-IT{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.it-IT{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.it-IT{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.it-IT{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}.tr-TR{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.tr-TR{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.tr-TR{
.u_c_07IV34.normal{
position:relative;

}
}.tr-TR{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.tr-TR{
.u_c_ORRX36.normal{
position:relative;

}
}.tr-TR{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.tr-TR{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.tr-TR{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.tr-TR{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.tr-TR{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.tr-TR{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.tr-TR{
.u_c_SPID29.normal{
position:relative;

}
}.tr-TR{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.tr-TR{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.tr-TR{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.tr-TR{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.tr-TR{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.tr-TR{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.tr-TR{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.tr-TR{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.tr-TR{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.tr-TR{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.tr-TR{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.tr-TR{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.tr-TR{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.tr-TR{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.tr-TR{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}.pl-PL{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.pl-PL{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.pl-PL{
.u_c_07IV34.normal{
position:relative;

}
}.pl-PL{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.pl-PL{
.u_c_ORRX36.normal{
position:relative;

}
}.pl-PL{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.pl-PL{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.pl-PL{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.pl-PL{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.pl-PL{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.pl-PL{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.pl-PL{
.u_c_SPID29.normal{
position:relative;

}
}.pl-PL{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.pl-PL{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.pl-PL{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.pl-PL{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.pl-PL{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.pl-PL{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.pl-PL{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.pl-PL{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.pl-PL{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.pl-PL{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.pl-PL{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.pl-PL{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.pl-PL{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.pl-PL{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.pl-PL{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}.id-ID{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.id-ID{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.id-ID{
.u_c_07IV34.normal{
position:relative;

}
}.id-ID{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.id-ID{
.u_c_ORRX36.normal{
position:relative;

}
}.id-ID{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.id-ID{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.id-ID{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.id-ID{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.id-ID{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.id-ID{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.id-ID{
.u_c_SPID29.normal{
position:relative;

}
}.id-ID{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.id-ID{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.id-ID{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.id-ID{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.id-ID{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.id-ID{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.id-ID{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.id-ID{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.id-ID{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.id-ID{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.id-ID{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.id-ID{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.id-ID{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.id-ID{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.id-ID{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}.ar-SA{
.u_c_6FRM32.normal{
position:relative;
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding:0.67rem 0 2.00rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005617-13.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_6FRM32.normal .txt{
font-size:0.29rem;
font-weight:normal;

}

.u_c_6FRM32.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.ar-SA{
.u_c_6B6A33.normal{
position:relative;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:-0.71rem;
font-size:0.53rem;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
width:6.04rem;
height:1.24rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005667-9.png);
display:flex;
justify-content:center;
align-items:center;

}
}.ar-SA{
.u_c_07IV34.normal{
position:relative;

}
}.ar-SA{
.u_c_2V2935.normal{
position:relative;
width:9.07rem;
margin:auto;
margin-top:0.47rem;
font-size:0.27rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;
box-sizing:border-box;
padding:0 0.27rem;

}

.u_c_2V2935.normal.text{
width:100%;
height:auto;

}
}.ar-SA{
.u_c_ORRX36.normal{
position:relative;

}
}.ar-SA{
.u_c_603N43.normal{
position:relative;
margin-top:0.27rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.ar-SA{
.u_c_5SDU44.normal{
position:relative;
margin-top:0.39rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.ar-SA{
.u_c_17O664.normal{
position:relative;
font-weight:bold;
margin:0 0.07rem;

}
}.ar-SA{
.u_c_NV8K46.normal{
position:relative;
margin-top:-0.08rem;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.ar-SA{
.u_c_ZW3O66.normal{
position:relative;
font-weight:bold;

}
}.ar-SA{
.u_c_GUYI137.normal{
position:relative;
width:8.35rem;
height:0.79rem;
background:no-repeat center;
background-size:100% 100%;
background-color:#414771;
margin:0 auto;
margin-top:0.41rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.29rem;
border:3px solid;
border-radius:0.47rem;
border-color:#ffdd7b;
font-weight:normal;

}
}.ar-SA{
.u_c_SPID29.normal{
position:relative;

}
}.ar-SA{
.u_c_609N139.normal{
position:relative;
padding:0 0.07rem;
font-weight:600;

}
}.ar-SA{
.u_c_YBQY24.normal{
position:relative;
box-sizing:border-box;
padding:0 0.27rem;
text-align:center;
line-height:1.5;

}
}.ar-SA{
.u_c_GQCU25.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.ar-SA{
.u_c_NY9J27.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ar-SA{
.u_c_3NV472.normal{
position:relative;
width:9.07rem;
height:100%;
margin:auto;
margin-top:0.39rem;
display:flex;
justify-content:center;
align-items:center;
flex-wrap:wrap;
font-size:0;
align-content:center;

}
}.ar-SA{
.u_c_59TC73.normal{
position:relative;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678499-36.png);
background-size:contain;
width:2.60rem;
height:2.63rem;
cursor:pointer;
margin:0.07rem;
display:flex;
align-items:center;
justify-content:center;

}
}.ar-SA{
.u_c_S4DS74.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-color:rgba(0,0,0,0.5);
display:none;

}
}.ar-SA{
.u_c_VRIH75.normal{
position:absolute;
width:100%;
height:100%;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559678627-34.png);
top:0;
left:0;

}
}.ar-SA{
.u_c_PC0C76.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.ar-SA{
.u_c_XUTD77.normal{
position:absolute;
width:1.33rem;
height:1.33rem;
background:no-repeat center;
background-size:contain;

}

.u_c_XUTD77.normal.has{
filter:brightness(0.7) saturate(.8);;

}
}.ar-SA{
.u_c_05SV78.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin:0 auto;
margin-top:0.23rem;

}

.u_c_05SV78.normal .lottery-btn-text{
font-size:0.33rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ar-SA{
.u_c_X39D79.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697449-44.png);

}

.u_c_X39D79.normal.has{
filter:grayscale(1);
cursor:default;

}
}.ar-SA{
.u_c_ZBZS80.normal{
position:relative;
margin-top:0.55rem;

}
}.ar-SA{
.u_c_1OP482.normal{
position:relative;
width:4.32rem;
height:1.63rem;
display:block;
margin:auto;
background:no-repeat center;
background-size:contain;
overflow:hidden;
text-decoration:none;
margin-left:-0.17rem;
cursor:pointer;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);

}
}.ar-SA{
.u_c_56AF83.normal{
position:relative;
margin-top:0.55rem;

}
}
</style>
